/*
  Сводка выгрузки 1С - что система увидела в отчёте, до записи и после неё.

  Вынесена из `OneCUpload` 20.10.2026, когда шаг с ходом загрузки двух файлов
  перешёл предел компонента в 300 строк. Граница та же, что у `ImportOutcome`:
  шаг ведёт человека от файлов к записи, а этот блок объясняет, что в отчёте.
*/

import { date, money, rows as rowsCount } from '../api/format.js'
import OneCSettled from './OneCSettled.jsx'

/*
  05.10.2026: отчёт с сальдо называет долг на дату, а не «начислено / оплачено».
  Долг месяца с этого дня - конечное сальдо (решение владельца), и в
  «начислено» входит остаток прошлых месяцев: пара сумм долга уже не объясняет.
  Отчёт без отчётного периода (`balance_as_of` пуст) показывается по-старому.
*/
function Money({ summary }) {
  if (summary.balance_as_of) {
    return (
      <p>
        Долг по выгрузке <b>{money(summary.debt)}</b> на {date(summary.balance_as_of)}.
      </p>
    )
  }
  return (
    <p>
      Начислено <b>{money(summary.accrued)}</b>, оплачено <b>{money(summary.paid)}</b>.
    </p>
  )
}

function deferralOf(outcome, summary) {
  if (!outcome || !summary.settle_deferred) return null
  return { runId: outcome.import_run_id, doubt: outcome.volume_doubt }
}

export default function OneCSummary({ summary, outcome, picked }) {
  const done = Boolean(outcome)
  return (
    <div className="onec__summary">
      <p>
        {picked ? 'Выбранных счетов' : 'Счетов'}: <b>{summary.accounts}</b>, услуг:{' '}
        <b>{summary.services}</b>, всего <b>{rowsCount(summary.rows)}</b>.
      </p>
      <Money summary={summary} />
      {summary.skipped.map((group) => (
        <p key={group.reason} className="onec__skipped">
          Не пойдёт в портфель: {rowsCount(group.rows)}. {group.explanation}
        </p>
      ))}
      <OneCSettled
        months={summary.settled}
        done={done}
        deferral={deferralOf(outcome, summary)}
      />
    </div>
  )
}
